module.exports = __webpack_public_path__ + "media/images/furniture-img-2-18e3cf83e8cc6278b3514178264151c1.jpg";